import { NavLink } from 'react-router-dom';
import { formatAddress, ITANI_NETWORK } from '../lib/blockchain';

const NAV_ITEMS = [
  { to: '/dashboard', label: 'Dashboard' },
  { to: '/wallet', label: 'Wallet' },
  { to: '/dex', label: 'DEX' },
  { to: '/bridge', label: 'Bridge' },
  { to: '/faucet', label: 'Faucet' },
  { to: '/explorer', label: 'Explorer' },
  { to: '/staking', label: 'Staking' },
  { to: '/compound', label: 'Compound' },
  { to: '/settings', label: 'Settings' },
];

function getWalletAddress(wallet, props) {
  return (
    wallet?.account ||
    wallet?.address ||
    wallet?.selectedAccount ||
    props?.account ||
    props?.address ||
    ''
  );
}

function getWalletConnect(wallet, props) {
  return (
    wallet?.connectWallet ||
    wallet?.connect ||
    props?.connectWallet ||
    props?.connect ||
    null
  );
}

function getNetworkLabel(wallet, props) {
  if (wallet?.chainName) {
    return wallet.chainName;
  }

  if (props?.chainName) {
    return props.chainName;
  }

  if (wallet?.isConnected || props?.isConnected || getWalletAddress(wallet, props)) {
    return 'iTani Ready';
  }

  return 'Wallet Offline';
}

function getSwitchToTestnet(wallet, props) {
  return wallet?.switchToTestnet || props?.switchToTestnet || null;
}

function getSwitchToMainnet(wallet, props) {
  return wallet?.switchToMainnet || props?.switchToMainnet || null;
}

export default function Header(props) {
  const wallet = props.wallet || props;
  const address = getWalletAddress(wallet, props);
  const connectWallet = getWalletConnect(wallet, props);
  const networkLabel = getNetworkLabel(wallet, props);
  const switchToTestnet = getSwitchToTestnet(wallet, props);
  const switchToMainnet = getSwitchToMainnet(wallet, props);
  const isTestnet = Boolean(wallet?.isTestnet || props?.isTestnet);

  return (
    <header className="sticky top-0 z-30 border-b border-white/10 bg-slate-950/80 backdrop-blur">
      <div className="mx-auto flex w-full max-w-7xl items-center justify-between gap-4 px-4 py-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-3">
          <div className="glass flex h-11 w-11 items-center justify-center rounded-2xl text-lg font-bold text-cyan-300">
            H
          </div>
          <div>
            <div className="text-lg font-semibold tracking-wide text-white">HudLife</div>
            <div className="text-xs uppercase tracking-[0.3em] text-slate-400">iTani dApp Suite</div>
          </div>
        </div>

        <nav className="hidden items-center gap-2 lg:flex">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                [
                  'rounded-xl px-3 py-2 text-sm font-medium transition',
                  isActive
                    ? 'bg-cyan-400/15 text-cyan-300'
                    : 'text-slate-300 hover:bg-white/5 hover:text-white',
                ].join(' ')
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={ITANI_NETWORK.testnet.home}
            target="_blank"
            rel="noreferrer"
            className="hidden rounded-xl border border-cyan-400/30 bg-cyan-400/10 px-3 py-2 text-sm font-semibold text-cyan-200 transition hover:bg-cyan-400/20 lg:inline-flex"
          >
            Open Testnet
          </a>

          {address ? (
            <button
              type="button"
              onClick={() => (isTestnet ? switchToMainnet && switchToMainnet() : switchToTestnet && switchToTestnet())}
              className="hidden rounded-xl border border-white/10 bg-white/5 px-3 py-2 text-sm font-medium text-white transition hover:bg-white/10 sm:inline-flex"
            >
              {isTestnet ? 'Switch Mainnet' : 'Switch Testnet'}
            </button>
          ) : null}

          <div className="glass hidden rounded-xl px-3 py-2 text-right sm:block">
            <div className="text-[11px] uppercase tracking-[0.2em] text-slate-400">Network</div>
            <div className="text-sm font-medium text-white">{networkLabel}</div>
          </div>

          {address ? (
            <div className="glass rounded-xl px-3 py-2 text-right">
              <div className="text-[11px] uppercase tracking-[0.2em] text-slate-400">Wallet</div>
              <div className="text-sm font-semibold text-cyan-300">{formatAddress(address)}</div>
            </div>
          ) : (
            <button
              type="button"
              onClick={() => connectWallet && connectWallet()}
              className="rounded-xl bg-cyan-400 px-4 py-2 text-sm font-semibold text-slate-950 transition hover:bg-cyan-300"
            >
              Connect Wallet
            </button>
          )}
        </div>
      </div>

      <div className="mx-auto flex w-full max-w-7xl gap-2 overflow-x-auto px-4 pb-4 lg:hidden sm:px-6 lg:px-8">
        <a
          href={ITANI_NETWORK.testnet.home}
          target="_blank"
          rel="noreferrer"
          className="whitespace-nowrap rounded-xl border border-cyan-400/30 bg-cyan-400/10 px-3 py-2 text-sm font-semibold text-cyan-200"
        >
          Open Testnet
        </a>

        {address ? (
          <button
            type="button"
            onClick={() => (isTestnet ? switchToMainnet && switchToMainnet() : switchToTestnet && switchToTestnet())}
            className="whitespace-nowrap rounded-xl border border-white/10 bg-white/5 px-3 py-2 text-sm font-medium text-white"
          >
            {isTestnet ? 'Switch Mainnet' : 'Switch Testnet'}
          </button>
        ) : null}

        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              [
                'whitespace-nowrap rounded-xl px-3 py-2 text-sm font-medium transition',
                isActive
                  ? 'bg-cyan-400/15 text-cyan-300'
                  : 'text-slate-300 hover:bg-white/5 hover:text-white',
              ].join(' ')
            }
          >
            {item.label}
          </NavLink>
        ))}
      </div>
    </header>
  );
}
